import type {
  CreatedAuthorModel,
  DeleteApiAuthorsIdPathParams,
} from '@/shared/api'
import { STRINGS } from '@/shared/config'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { createEvent, createStore, sample } from 'effector'
import { createGate } from 'effector-react'

import {
  authorByIdQuery,
  authorCreate,
  authorDelete,
  authorUpdate,
} from '../api'

// By Id
interface AuthorGateProps {
  id: string
}
export const AuthorGate = createGate<AuthorGateProps>()

sample({
  clock: AuthorGate.open,
  fn: ({ id }: AuthorGateProps) => ({ id }),
  target: authorByIdQuery.start,
})

sample({
  clock: AuthorGate.close,
  target: authorByIdQuery.reset,
})

sample({
  clock: authorCreate.finished.success,
  fn: () => ({ message: STRINGS.success_creation }),
  target: showNotificationSuccessFx,
})

sample({
  clock: authorUpdate.finished.success,
  fn: () => ({ message: STRINGS.success_update }),
  target: showNotificationSuccessFx,
})

export const authorDeleted = createEvent<{
  id: DeleteApiAuthorsIdPathParams['Id']
}>()

sample({
  clock: authorDeleted,
  fn: ({ id }) => ({ id }),
  target: [authorDelete.start],
})

sample({
  clock: authorDelete.finished.success,
  fn: () => ({ message: STRINGS.success_deletion }),
  target: showNotificationSuccessFx,
})

export const $lastCreatedAuthor = createStore<CreatedAuthorModel | null>(null)

sample({
  clock: authorCreate.finished.success,
  fn: ({ result: { id, nickname } }): CreatedAuthorModel => ({ id, nickname }),
  target: $lastCreatedAuthor,
})
